export const SET_PATIENT_LOCATION = 'SET_PATIENT_LOCATION';
export const SET_SEARCH_STATE = 'SET_SEARCH_STATE';
